import LoadingSvg from "@lyteflo/assets/icons/loading-spinner.svg?react";

export const PullToRefreshSpinner = () => {
  return (
    <div className="lf-h-10 lf-w-10 lf-flex lf-items-center lf-justify-center">
      <LoadingSvg />
    </div>
  );
};
